export default __webpack_public_path__ + "static/media/portfolio-5.de0895bc.jpg";